import { fork, put, takeLatest, select } from 'redux-saga/effects';

import {
    ACTIVATE_RLS_DASHBOARD,
    RLS_DASHBOARD_READY
} from './Dashboard.actions';
import * as selectors from './dashboardSelectors';
import { putAndWaitHandleAllAPIError } from '../../../api/API.sagas';
import * as lendingApiActions from '../../../api/lendingAPI/LendingAPI.actions';

export const RLSDashboardSagasWorkers = [fork(RLSDashboardPageWorkers)];

function* RLSDashboardPageWorkers() {
    yield takeLatest(ACTIVATE_RLS_DASHBOARD, function* () {
        yield putAndWaitHandleAllAPIError([
            { type: lendingApiActions.API_GET_CUSTOMER_STATE },
            { type: lendingApiActions.API_GET_ACCOUNTS }
        ]);

        const dashboardStatus = yield select(selectors.getDashboardStatus);

        yield put({
            type: RLS_DASHBOARD_READY,
            status: dashboardStatus
        });
    });
}
